import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

import {CHETWODEBLUE, OzCard, OzIcon} from "@ozwol/webui";

import CardHeaderTitle from '../components/CardHeaderTitle';

import {convertNumber} from '../helpers';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Left = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 10px;

  display: flex;
  align-items: center;
`;
const Right = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  text-align: right;
  margin-left: 10px;
  display: flex;
  justify-content: flex-end;
`;
const Icon = styled.div`
  margin-bottom: -5px;
`;
const Block = styled.div`
  text-align: center;
  padding-left: 30px;
  margin-left: 30px;
  border-left: 1px solid #707070;
`;
const Label = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #303030;
  margin-bottom: 2px;

	a &{
		color: ${CHETWODEBLUE};
	}
`;
const Value = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #303030;
`;
const BigValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #303030;
`;

const PeriodTotal = ({ numRecharges = null, totRecharges=0, totCustomizations=0, planName, planPrice, isDeletingAccount = false }) => {

  return (
    <OzCard>
      <Wrapper>
        <Left>
          <Icon><OzIcon name={"bill"} size="25px" /></Icon>
          <CardHeaderTitle title="Current period total" />
        </Left>
        <Right>
          <Block>
            <Link to="/overall/recharges"><Label>Recharges</Label></Link>
            <Value>({numRecharges}) {convertNumber(totRecharges, 0)} €</Value>
          </Block>{}
          <Block>
						<Link to="/overall/recharges"><Label>Customizations</Label></Link>
            <Value>{convertNumber(totCustomizations, 0)} €</Value>
          </Block>
          {!isDeletingAccount ?
            <Block>
              <Link to="/account/plans"><Label>{planName} plan</Label></Link>
              <Value>{convertNumber(planPrice, 0)} €</Value>
            </Block>
          : null }
          <Block>
            <Label>Total</Label>
            <BigValue>{convertNumber(parseInt(totRecharges) + parseInt(totCustomizations) + parseInt(!isDeletingAccount ? planPrice : 0), 0)} €</BigValue>
          </Block>
        </Right>
      </Wrapper>
    </OzCard>
  );
}

export default PeriodTotal;
